<template>
	<div class="profile">
		<div class="page__header">
			<h1>Profile {{profile.username}}</h1>
			<span v-if="!isSelf">
				<button
					@click="befriend"
					v-if="!isFriend && !requestSent && !requestPending"
					class="friend">
					<i class="fas fa-user-plus"></i>
					Add friend
				</button>
				<button
					v-else-if="!isFriend && requestSent"
					class="friend">
					<i class="fas fa-user-clock"></i>
					Friend request sent
				</button>
				<span v-else-if="!isFriend && requestPending">
					<button
						@click="befriend"
						class="friend">
						<i class="far fa-check-circle"></i>
						Accept friend request
					</button>
					<button
						@click="unfriend({ confirmation: false })"
						class="friend">
						<i class="far fa-times-circle"></i>
						Decline friend request
					</button>
				</span>
				<span v-else-if="isFriend">
					<button
						class="friend">
						<i class="fas fa-user-check"></i>
						Friends
					</button>
					<button
						@click="unfriend({ confirmation: true })"
						class="friend--unfriend">
						<i class="fas fa-trash"></i>
						Unfriend
					</button>
				</span>
			</span>
		</div>
		<div class="page__content--overlap">
			<div class="info">
				<h2>{{profile.first_name}} {{profile.last_name}}</h2>
				<p v-if="profile.School">{{profile.School.name}}</p>
				<p v-if="profile.Program">{{profile.Program.title}}</p>
			</div>
			<PlanningGrid :plannings="profile.Plannings"></PlanningGrid>
			<div class="friends">
				<h2 v-if="friends">{{profile.username}}'s friends ({{friends.length}})</h2>
				<router-link
					v-for="friend in friends"
					:key="friend.User.username"
					tag="p"
					:to="`/profile/${friend.User.username}`">
					{{friend.User.username}}
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import PlanningGrid from '@/components/PlanningGrid'
import ProfileService from '@/services/ProfileService'
export default {
	components: {
		PlanningGrid
	},
	data () {
		return {
			profile: {
				Program: [],
				School: []
			}
		}
	},
	methods: {
		async getProfile (username) {
			const options = {
				includePlannings: true,
				includeFriends: true
			}
			this.profile = await ProfileService.get(username, options)
		},
		async befriend () {
			await ProfileService.befriend(this.profile.username)
			this.$store.dispatch('getFriends')
		},
		async unfriend (options) {
			var confirmed = false
			if (options.confirmation) {
				confirmed = confirm('Do you really wish to unfriend this person?')
			}
			if (!options.confirmation || confirmed) {
				await ProfileService.unfriend(this.profile.username)
				this.$store.dispatch('getFriends')
			}
		}
	},
	computed: {
		isSelf () {
			return this.profile.id === this.$store.state.authentication.user.id
		},
		isFriend () {
			// Check if this user is in the global friend list
			const friendNames = this.$store.state.social.friendNames
			if (!friendNames) return false
			return friendNames.includes(this.profile.username)
		},
		requestPending () {
			// Check if we have receieved a request from this user
			const username = this.$store.state.authentication.user.username
			const request = this.$store.state.social.friendRequests.find(request =>
				request.Receiver.username === username && request.Sender.username === this.profile.username
			)
			return !!request
		},
		requestSent () {
			// Check if we have sent a request to this user which is still pending
			const username = this.$store.state.authentication.user.username
			const request = this.$store.state.social.friendRequests.find(request =>
				request.Sender.username === username && request.Receiver.username === this.profile.username
			)
			return !!request
		},
		friends () {
			var friends = []
			if (this.profile.Friends) {
				this.profile.Friends.forEach(friend => {
					if (friend.User) friends.push(friend)
				})
			}
			return friends
		}
	},
	watch: {
		async '$route' () {
			this.getProfile(this.$route.params.username)
		}
	},
	created () {
		this.getProfile(this.$route.params.username)
	}
}
</script>

<style lang="scss" scoped>
.friend {
	@extend %button--primary;
	&--unfriend {
		@extend %button--tertiary;
	}
}
.info {
	@extend %brick;
	margin-bottom: $spacing-5;
}
.friends {
	@extend %brick;
	margin-bottom: $spacing-5;
}
</style>
